export default "__VITE_ASSET__BSBfvgpB__"